import { Box } from '@mui/material';
import SidebarLayout from './SidebarLayout';

/*
    FinanceLayout

    The FinanceLayout renders the LoggedInLayout, so it can be thought of as
    a child interpretation of that layout, in a way.

    The layout is responsible for three things:
      1. Managing global Finance data (currently only FinanceSnapshots)
      2. Rendering global Finance dialogs
      3. Rendering the Finance product UI CSS grid

    The third piece means that all pages in the Finance product need to know 
    about the grid so they render properly. But this way, we have consistency
    without having to write a lot of code, and we don't need fixed position 
    hacks any longer.
*/
export default function FinanceLayoutWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SidebarLayout>
      <Box
        data-testid="FinanceLayout"
        sx={{
          position: 'relative',
          width: '100%',
          height: '100vh',
          display: 'grid',
          gridTemplateRows: 'auto 1fr',
          gridTemplateColumns: '1fr 0.5fr',
          backgroundColor: 'grey10',
        }}
      >
        {children}
      </Box>
    </SidebarLayout>
  );
}
